@let t = team();

@if (t) {
  <div class="tooltip-card">
    <!-- Header: driver info + car number badge -->
    <div class="tooltip-header">
      <div class="tooltip-driver-info">
        <div class="tooltip-driver-name">{{ t.currentDriverFullName }}</div>
        @if (t.drivers?.[t.currentDriver]?.country) {
          <div class="tooltip-country">
            <span class="country-code"> Country: {{ t.drivers[t.currentDriver].country }}</span>
          </div>
        }
        <div class="tooltip-vehicle">Vehicle: {{ t.manufacturer || t.vehicle }}</div>
        <div class="tooltip-team">Team: {{ t.team }}</div>
      </div>
      <div
        class="tooltip-car-badge"
        [style.border]="'1px solid var(--secondary)'"
        [style.background]="'linear-gradient(135deg, rgba(255,128,0,0.12) 0%, rgba(255,128,0,0.04) 100%)'"
        [style.color]="'var(--secondary)'"
      >
        <span class="car-number">#{{ t.number }}</span>
        <span class="car-class">{{ t.class }}</span>
      </div>
    </div>

    <!-- Detail grid -->
    <div class="tooltip-details">
      <div class="tooltip-detail">
        <span class="detail-label">BEST LAP</span>
        <span class="detail-value accent-blue">
          {{ t.participantDetails?.bestLap?.time | timespanMs }}
        </span>
      </div>
      <div class="tooltip-detail">
        <span class="detail-label">AVG SPEED</span>
        <span class="detail-value accent-blue">
          @if (t.participantDetails?.avgSpeed != null) {
            {{ t.participantDetails.avgSpeed | number: '1.1-1' }} km/h
          } @else if (t.participantDetails?.bestTopSpeed != null) {
            {{ t.participantDetails.bestTopSpeed | number: '1.1-1' }} km/h
          } @else {
            —
          }
        </span>
      </div>
    </div>

    <div class="tooltip-footer">
      <span class="status-dot"></span>
      <span>
        P{{ t.activeStanding?.position }}
        @if (t.activeStanding?.gapFirstLaps > 0) {
          {{ t.activeStanding.gapFirstLaps }}L
        } @else if (t.activeStanding?.gapFirstTime) {
          +{{ t.activeStanding.gapFirstTime | timespanShort }}
        }
      </span>
    </div>
  </div>
}
